import { useState } from "react"
import { Helmet } from "react-helmet-async"
import {
	IntegrationItem,
	isOAuthIntegration,
	type TOAuthClientCredentials,
} from "./../../../../Integrations"
import { Navigate, useLocation, useParams } from "../../../../router-utils"

/**
 * What a create flow may hand over through navigation state: the API
 * integration's one-time token, or the OAuth app's one-time credentials.
 */
type TCreatedSecretState =
	| string
	| { oauth_client: TOAuthClientCredentials }
	| null
	| undefined

export default function IntegrationItemDetailsPage() {
	const location = useLocation()
	const { integrationId } = useParams("/integrations/:integrationId")
	const state = location.state as TCreatedSecretState
	const [lastCreatedToken, setLastCreatedToken] = useState<string | undefined>(
		typeof state === "string" ? state : undefined
	)
	const [createdOAuthClient] = useState<TOAuthClientCredentials | undefined>(
		state && typeof state === "object" ? state.oauth_client : undefined
	)
	return (
		<>
			<Helmet>
				<title>Integration Details</title>
			</Helmet>
			<IntegrationItem
				lastCreatedToken={lastCreatedToken}
				createdOAuthClient={createdOAuthClient}
				integrationId={integrationId}
				setLastCreatedToken={setLastCreatedToken}
			>
				{({ integration }) =>
					integration.platform === "pg_payu" ||
					integration.platform === "pg_simulator" ? (
						<Navigate
							to={"/integrations/:integrationId/pg"}
							params={{ integrationId }}
							replace
						/>
					) : integration.platform === "whatsapp_cloud_api" ||
					  integration.platform === "whatsapp_simulator" ? (
						<Navigate
							to={"/integrations/:integrationId/whatsapp"}
							params={{ integrationId }}
							replace
						/>
					) : integration.platform === "email_mailbox" ? (
						<Navigate
							to={"/integrations/:integrationId/mail"}
							params={{ integrationId }}
							replace
						/>
					) : isOAuthIntegration(integration) ? (
						<Navigate
							to={"/integrations/:integrationId/oauth"}
							params={{ integrationId }}
							replace
						/>
					) : null
				}
			</IntegrationItem>
		</>
	)
}
